module.exports = __webpack_public_path__ + "img/ct-icon-company.f9233179.svg";